export enum EventScope {
    event, user
  }
